<style scoped>
</style>
<template>
  <v-app id="topup">
    <v-container>
      <v-layout row wrap>
        <v-flex md6 xs12>
          <topup v-if="secret" :secret="secret" type="public" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
const TopUp = () => import("@/components/charts/payment/topup.vue");
export default {
  data: () => ({
    secret: null,
  }),
  methods: {},
  components: {
    topup: TopUp,
  },
  mounted() {
    this.secret = this.$route.params.secret;
  },
  beforeCreate() {},
};
</script>
